import { useState } from "react";
import { Copy, Download, Check } from "lucide-react";
import { saveBlob } from "./api";

export const RecoveryCodes = ({ codes, onDone, doneLabel = "I've saved my codes" }) => {
  const [copied, setCopied] = useState(false);
  const text = `First Responders Foundation staff recovery codes\nEach code works once.\n\n${codes.join("\n")}\n`;
  const copy = async () => {
    try { await navigator.clipboard.writeText(text); setCopied(true); } catch { setCopied(false); }
  };
  return (
    <div data-testid="recovery-codes-panel">
      <p className="text-sm font-semibold text-navy">Save your recovery codes</p>
      <p className="mt-2 text-sm text-slate">
        If you lose or replace your phone, sign in with one of these codes instead of an authenticator code.
        Each code works once. They are shown only now. Store them somewhere safe, like a password manager or a printed copy kept locked away.
      </p>
      <ul className="mt-5 grid grid-cols-2 gap-2 bg-mist p-4 font-mono text-sm text-navy" data-testid="recovery-codes-list">
        {codes.map((c) => <li key={c}>{c}</li>)}
      </ul>
      <div className="mt-5 flex flex-wrap gap-3">
        <button type="button" onClick={copy} className="btn btn-ghost" data-testid="recovery-codes-copy-button">
          {copied ? <Check size={16} /> : <Copy size={16} />} {copied ? "Copied" : "Copy"}
        </button>
        <button type="button" onClick={() => saveBlob(new Blob([text], { type: "text/plain" }), "frf-recovery-codes.txt")}
          className="btn btn-ghost" data-testid="recovery-codes-download-button">
          <Download size={16} /> Download
        </button>
      </div>
      <button type="button" onClick={onDone} className="btn btn-navy mt-6 w-full" data-testid="recovery-codes-done-button">
        {doneLabel}
      </button>
    </div>
  );
};
